// extracted by mini-css-extract-plugin
export var bubble = "widget-box-module--bubble--1U-Tc";
export var icon = "widget-box-module--icon--WlJsa";
export var widgetBox = "widget-box-module--widget-box--aI6kM";